import { Button, TableCell } from "@mui/material";
import {FaCheck, FaEye, FaPencilAlt, FaTimes} from "react-icons/fa";
import {Link} from "react-router-dom";
import React from "react";
const ActionsCell = ({ update, handleShowDetails }) => (
  <TableCell align="center">
    <div className="flex gap-2 justify-center items-center">
      <Button
        variant="outlined"
        color="info"
        size="small"
        onClick={() => handleShowDetails(update)}
      >
        View Details
      </Button>


    </div>
  </TableCell>
);
export default ActionsCell;
